require 'angular'

angular.module('workflow.app')

.directive 'messages', ($rootScope, $window, $sanitize, $sce) ->
  return {
    link: (scope, element, $state) ->
      clearMessage = () ->
        scope.message = $rootScope.message = $window.message = false

      clearError = () ->
        scope.error = $rootScope.error = $window.error = false

      messageHandler = (val) ->
        scope.message = val

        stateChange = $rootScope.$on '$stateChangeStart', () ->
          clearMessage()
          stateChange()

      errorHandler = (val) ->
        scope.error = val

        stateChange = $rootScope.$on '$stateChangeStart', () ->
          clearError()
          stateChange()

      errorTypeHandler = (val) ->
        scope.error_type = val

      scope.close = () ->
        clearMessage()
        clearError()

      scope.to_trusted = (html) ->
        return $sce.trustAsHtml(html)

      $rootScope.$watch (-> $window.message), messageHandler
      $rootScope.$watch (-> $window.error), errorHandler
      $rootScope.$watch (-> $window.error_type), errorTypeHandler

      $rootScope.$watch 'message', messageHandler
      $rootScope.$watch 'error', errorHandler

    template: require('./messages.html')
  }
